export enum ContainersEntityTypes {
    PackingBox = "Packing Box",
    OuterCube = "Pallet"
}